// extracted by mini-css-extract-plugin
export var smallSpinner = "_xb-0";